export const EXECUTION_ENGINE_COLUMNS = [
  'رقم طلب التنفيذ', 'رقم سند إيفاء', 'رقم الدعوى الموحد', 'رقم المخالفة',
  'رقم السداد', 'رقم الدعوى الابتدائية', 'رقم الاستئناف', 'الشركة',
  'الجهة المنفذة', 'دائرة التنفيذ', 'تاريخ التنفيذ هجري', 'تاريخ التنفيذ ميلادي',
  'وجود استئناف', 'حكم نهائي',
];

export const EXECUTION_ENGINE_STATES = {
  pending_approval: 'بانتظار مراجعة المشرف', queued_technical: 'بانتظار القسم التقني',
  starting: 'جار تجهيز التشغيل', running: 'قيد التشغيل', completed: 'مكتمل',
  partial: 'إنجاز جزئي', upload_pending: 'السحب مكتمل · الرفع متبقٍ',
  failed: 'يحتاج متابعة', rejected: 'مرفوض', cancelled: 'ملغى',
};

export function executionEngineNumber(value) {
  return String(value ?? '').normalize('NFKC').replace(/[٠-٩]/g, digit => String(digit.charCodeAt(0) - 0x660))
    .replace(/[۰-۹]/g, digit => String(digit.charCodeAt(0) - 0x6f0))
    .replace(/[\u200e\u200f\u202a-\u202e\u2066-\u2069]/g, '').trim();
}

export function executionEngineRow(record, companyName, kind) {
  const data = record.workflowData || JSON.parse(record.workflow_data_json || '{}');
  const values = [record.execution_request_number, record.bond_number, data.unifiedCaseNumber,
    record.source_violation_number || data.violationNumbers, record.payment_number,
    data.initialCaseNumber || record.source_initial_case_number, data.appealCaseNumber || record.source_appeal_case_number,
    companyName, record.government_entity, record.execution_court_circle,
    record.execution_order_date_hijri, record.execution_order_date,
    data.appealCaseNumber || record.source_appeal_case_number ? 'نعم' : '', kind === 'final' ? 'نعم' : ''];
  return Object.fromEntries(EXECUTION_ENGINE_COLUMNS.map((key, index) => [key, index < 7 ? executionEngineNumber(values[index]) : String(values[index] ?? '')]));
}
